import { Button, Modal, Typography, Select, Input } from 'antd';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import httpInjectorService from 'services/http-injector.service';

const { Option } = Select;
const { Text } = Typography;

const InviteProject = ({ open, onClose, projectId }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [projectRoleId, setProjectRoleId] = useState(null);
  const [orgRoleId, setOrgRoleId] = useState(null);

  const validateEmails = (value) => {
    if (!value) return 'Email is required';

    const emails = value.split(',').map((e) => e.trim());
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    for (let mail of emails) {
      if (!regex.test(mail)) {
        return 'Please enter valid email address(es)';
      }
    }
    return '';
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setError(validateEmails(value));
  };

  const resetForm = () => {
    setEmail('');
    setError('');
    setProjectRoleId('');
    setOrgRoleId('');
  };

  const handleSendInvite = async () => {
    try {
      const emailsArray = email
        .split(',')
        .map((e) => e.trim())
        .filter(Boolean);

      const reqBody = {
        project_id: Number(projectId),        
        emails: emailsArray,                  
        org_role_id: Number(orgRoleId),        
        project_role_id: Number(projectRoleId)
      };

      const response = await httpInjectorService.sendProjectInvite(reqBody);

      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 1000,
        });
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 1000,
        });
      }

      resetForm();
      onClose();

    } catch (err) {
      toast.error(err?.message || 'Invite failed', {
        position: 'top-right',
        autoClose: 1000,
      });
      resetForm();
      onClose();
    }
  };

  return (
    <Modal
      title="Invite people to Project"
      open={open}
      onCancel={onClose}
      width={800}
      destroyOnClose
      footer={[
        <Button key="cancel" danger onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="send"
          color='purple'
          variant='solid'
          disabled={!!error || !email || !projectRoleId || !orgRoleId}
          onClick={handleSendInvite}
        >
          Send Invite
        </Button>,
      ]}
    >
      {/* Email */}
      <label>
        Email addresses <span style={{ color: 'red' }}>*</span>
      </label>

      <Input
        placeholder="Invite by email address…"
        value={email}
        onChange={handleEmailChange}
      />

      {error && (
        <Text type="danger" style={{ display: 'block', marginTop: 8 }}>
          {error}
        </Text>
      )}

      <Text type="secondary" style={{ marginTop: 8, display: 'block' }}>
        Separate multiple emails using a comma.
      </Text>

      {/* Org Role */}
      <div style={{ marginTop: 16 }}>
        <label>
          Select Organization Role <span style={{ color: 'red' }}>*</span>
        </label>

        <Select
          placeholder="Select Organization Role"
          value={orgRoleId}
          onChange={setOrgRoleId}
          style={{ width: '100%' }}
        >
          <Option value="2">Admin</Option>
          <Option value="2">Administrator</Option>
          <Option value="3">Member</Option>
        </Select>
      </div>

      {/* Project Role */}
      <div style={{ marginTop: 16 }}>
        <label>
          Select Project Role <span style={{ color: 'red' }}>*</span>
        </label>

        <Select
          placeholder="Select Project Role"
          value={projectRoleId}
          onChange={setProjectRoleId}
          style={{ width: '100%' }}
        >
          <Option value="1">Admin</Option>
          {/* <Option value="2">Project Lead</Option> */}
          <Option value="3">Member</Option>
          {/* <Option value="4">QA</Option> */}
          <Option value="5">Viewer</Option>
        </Select>
      </div>
    </Modal>
  );
};

export default InviteProject;
